/** 选中角标图片 */
export const SELECTED_BADGE_IMG = "https://image.douquan.com/prod/admin/coin/2025-06-27/1751012906505652.png";